// consent-gated, interaction-lazy FB Pixel (GDPR-safe)
(function () {
  var PIXEL_ID = '1173992133591935';
  var loaded = false;
  function loadPixel() {
    if (loaded) return; loaded = true;
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}
    (window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', PIXEL_ID); fbq('track', 'PageView');
  }
  var consentOk = false, interacted = false;
  function maybeFire() { if (consentOk && interacted) loadPixel(); }
  ['mousemove','scroll','touchstart','keydown','click'].forEach(function (evt) {
    window.addEventListener(evt, function () { interacted = true; maybeFire(); }, { once: true, passive: true });
  });
  function checkConsent() {
    if (!window.Shopify || !window.Shopify.customerPrivacy) { consentOk = true; maybeFire(); return; }
    var c = window.Shopify.customerPrivacy.getTrackingConsent();
    if (c === 'yes' || c === undefined) { consentOk = true; maybeFire(); }
    document.addEventListener('trackingConsentAccepted', function () { consentOk = true; maybeFire(); });
  }
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1',
      onLoad: function (err) { if (!err) checkConsent(); else { consentOk = true; maybeFire(); } } }]);
  } else { document.addEventListener('DOMContentLoaded', checkConsent); }
})();
